import type { RebuildInventoryPayload } from '../../../types'
import type { RebuildInventoryFormState } from '../RebuildInventoryPage.types'

// Maps the form state to the request body based on the explicitly-selected mode.
// Event-scoped mode always sends inventorySystemType; ISP-scoped mode only sends the
// fields the operator actually set. rebuildFilterPrices is only meaningful (and only
// sent) in event-scoped mode.
export function buildRebuildInventoryPayload(
  state: RebuildInventoryFormState,
): RebuildInventoryPayload {
  if (state.mode === 'event') {
    return {
      sysEventIds: state.sysEventIds,
      inventorySystemType: state.inventorySystemType,
      ...(state.tenantGroupCodes.length
        ? { tenantGroupCodes: state.tenantGroupCodes }
        : {}),
      ...(state.rebuildFilterPrices ? { rebuildFilterPrices: true } : {}),
    }
  }

  return {
    ...(state.tenantGroupCodes.length
      ? { tenantGroupCodes: state.tenantGroupCodes }
      : {}),
    ...(state.inventorySystemType
      ? { inventorySystemType: state.inventorySystemType }
      : {}),
  }
}
